import { useTranslation } from 'react-i18next';

export function SocketSessionRetry({ paused, retry }: { paused: boolean; retry: () => void }) {
  const { t } = useTranslation('auth');
  if (!paused) return null;
  return (
    <div role="alert" className="shrink-0 bg-warning/15 p-3">
      <span>{t('socketPaused')}</span>{' '}
      <button type="button" className="btn btn-sm" onClick={retry}>
        {t('socketRetry')}
      </button>
    </div>
  );
}
